// extracted by mini-css-extract-plugin
export default {"title":"WIoVz1","remaining-time-tiles-container":"brDv2x","remaining-time-tile":"uHxoYs","total-delay-time-tile":"vk5nL_"};